import { color, size } from "../foundation";
import { effects, state } from "../semantic";
import { buildShadow } from "../semantic/effects";

const { primary, neutral, error, tertiary, warning } = color;

export const button = {
    size: {
        sm: size[800],   // size for small buttons (height for text buttons, width and height for icon buttons)
        md: size[1000],  // size for medium buttons (height for text buttons, width and height for icon buttons)
        lg: size[1200],  // size for large buttons (height for text buttons, width and height for icon buttons)
        radius: {
            text: effects.radius.sm,   // border radius for text buttons
            icon: effects.radius.md,   // border radius for icon buttons
        }
    },
    spacing: {
        padding: {  // Horizontal padding for text buttons. Icon buttons have fixed size for button and icon, so no padding is needed
            sm: size[300],
            md: size[350],
            lg: size[400],
        },
        gap: {    // gap between icon and text for buttons that contain both
            default: size[200],  // default gap size for buttons
            lg: size[300],      // larger gap size for large buttons
        },
    },
    color: {
        filled: {
            bg: {
                primary: {
                    default: primary[600],
                    hover: primary[500],
                    active: primary[700],
                },
                secondary: {
                    default: neutral.white,
                    hover: neutral[200],
                    active: neutral[300],
                    disabled: neutral[100]
                },
                destructive: {
                    default: error[600],
                    hover: error[500],
                    active: error[700],
                },
                accent: {
                    default: tertiary[600],
                    hover: tertiary[500],
                    active: tertiary[700],
                },
                warning: {
                    default: warning[600],
                    hover: warning[500],
                    active: warning[700],
                }
            },
            border: {
                secondary: neutral[400],
            },
            content: {
                default: neutral.white,
                secondary: neutral[800],
            }
        },
        stateful: {
            bg: {
                inactive: {
                    default: neutral[200],
                    hover: neutral[300],
                },
                active: {
                    default: primary[100],
                    hover: primary[200],
                },
            },
            content: {
                inactive: neutral[700],
                active: primary[600],
            }
        },
        ghost: {
            bg: {
                hover: neutral[200],
                active: neutral[300],
            },
            content: {
                primary: primary[600],
                secondary: neutral[800],
                tertiary: {
                    default: primary[600],
                    disabled: neutral[800]
                },
                destructive: error[600],
                accent: tertiary[600],
                warning: warning[600],
            }
        }
    },
    effects: {
        shadow: {
            primary: {
                default: buildShadow(primary[600], 'sm'),  // filled button default
                floating: buildShadow(primary[600], 'lg'),  // elevated shadow for floating action buttons
            },
            secondary: {
                default: buildShadow(neutral[400], 'sm'),
                floating: buildShadow(neutral[400], 'lg'),
            },
            destructive: {
                default: buildShadow(error[600], 'sm'),
            },
            accent: {
                default: buildShadow(tertiary[600], 'sm'),
                floating: buildShadow(tertiary[600], 'lg'),
            },
            warning: {
                default: buildShadow(warning[600], 'sm'),
            },
        },
    },
}

export default button;